import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useRequiredWorkTimeEntryToCreate } from '../../../hooks/createWorkTimeEntry/useRequiredWorkTimeEntryToCreate';
import { useConfigureBreadcrumbsWithBuilder } from '../../../hooks/misc/useConfigureBreadcrumbsWithBuilder';
import { useAppDispatch } from '../../../store/hooks';
import { createWorkTimeEntrySlice } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
import {
  CreateConstructionSitePageContent,
  CreateConstructionSitePageContentProps
} from '../../constructionSite/CreateConstructionSitePageContent/CreateConstructionSitePageContent';

export type CreateWorkTimeEntryCreateConstructionSitePageProps =
  PropsWithoutChildren<Record<never, never>>;

export const CreateWorkTimeEntryCreateConstructionSitePage: FunctionComponent<CreateWorkTimeEntryCreateConstructionSitePageProps> =
  React.memo((props) => {
    prepareProps({ props, ignoreChildren: true });

    useConfigureBreadcrumbsWithBuilder((builder) =>
      builder
        .addHomePage()
        .addCreateWorkTimeEntryPage()
        .addCreateWorkTimeEntrySelectConstructionSitePage()
        .addCreateWorkTimeEntryCreateConstructionSitePage()
    );

    const workTimeEntryToCreate = useRequiredWorkTimeEntryToCreate();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleConstructionSiteCreated: CreateConstructionSitePageContentProps['onConstructionSiteCreated'] =
      useEventCallback((container) => {
        dispatch(
          createWorkTimeEntrySlice.actions.setConstructionSiteId(
            container.getLatest().id
          )
        );
        navigate(RoutePaths.createWorkTimeEntry());
      });

    const handleCancel = useEventCallback(() => {
      navigate(RoutePaths.createWorkTimeEntrySelectConstructionSite());
    });

    return (
      <CreateConstructionSitePageContent
        userGroupId={workTimeEntryToCreate.userGroupId}
        onConstructionSiteCreated={handleConstructionSiteCreated}
        onCancel={handleCancel}
        data-testid="CreateWorkTimeEntryCreateConstructionSitePage.PageContent"
      ></CreateConstructionSitePageContent>
    );
  });
